var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('OrdersTable',{attrs:{"isReadOnly":_vm.isReadOnly},on:{"create-order":_vm.onCreateOrder,"edit-order":_vm.onEditOrder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }